import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';

interface ISnackbarProps {
    isVisible: boolean;
    heading: string;
    text: string;
    linkUrl: string;
    linkText: string;
    onClose: () => void;
    className?: string;
    onLinkClick?: () => void;
    autoHide?: boolean;
}

export const Snackbar = (props: ISnackbarProps) => {
    const [isHidden, setIsHidden] = useState(true);
    const [isClosed, setIsClosed] = useState(true);

    const autoHideTimeout = 10000;
    const hideAnimationDuration = 1000;
    const closeModalTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
    const fadeModalTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (props.isVisible) {
            setIsHidden(false);
            setIsClosed(false);
            setHideTimeouts();
        }
    }, [props.isVisible]);

    const clearTimeouts = () => {
        fadeModalTimeout.current && clearTimeout(fadeModalTimeout.current);
        closeModalTimeout.current && clearTimeout(closeModalTimeout.current);
    };

    const setHideTimeouts = () => {
        if (props.autoHide) {
            fadeModalTimeout.current = setTimeout(() => {
                setIsHidden(true);
            }, autoHideTimeout - hideAnimationDuration);

            closeModalTimeout.current = setTimeout(() => {
                setIsClosed(true);
                props.onClose();
            }, autoHideTimeout);
        }
    };

    const handleClose = () => {
        setIsClosed(true);
        setIsHidden(true);
        props.onClose();
    };

    return isClosed ? null : (
        <div className={classNames('Snackbar', props.className, isHidden && 'Snackbar--Hidden')} onMouseEnter={clearTimeouts} onMouseLeave={setHideTimeouts}>
            <button className="Modal__CloseButton" onClick={handleClose}>
                <span className="visuallyHidden">{getTranslation(keys['navigation.close'])}</span>
            </button>

            <div className="Snackbar__Content">
                <span className="Snackbar__Icon" />
                <div>
                    <h3>{props.heading}</h3>
                    <p>{props.text}</p>
                    <a href={props.linkUrl} onClick={props.onLinkClick}>
                        {props.linkText}
                    </a>
                </div>
            </div>
        </div>
    );
};
